import { FC, useEffect, useState } from 'react'
import { ITicket } from '../../model/ITicket'
import Modal from '../common/modal/Modal'
import Button from '../form/Button'
import Input from '../form/Input'
import { useTicket } from '../../hooks/useTicket'
import toast from 'react-hot-toast'
import { msg } from '../../msg'
import parseISOToString from '../../utils/parseISOToString'
import TextButton from '../common/buttom/TextButton'

const TicketInternalNote: FC<{ ticket: ITicket }> = ({ ticket }) => {
  const [isShown, setIsShown] = useState<boolean>(false)
  const [internalNote, setInternalNote] = useState<string>()
  const { editTicketParams } = useTicket()

  const handleEditInternalNote = (internalNote: string) => async () => {
    try {
      await editTicketParams({
        idTicket: ticket.id,
        internalNote,
      })
      toast.success(msg('success-ticket-editing'))
      setIsShown(() => false)
    } catch (err) {}
  }

  useEffect(() => {
    setInternalNote(() => ticket?.internalNote || undefined)
  }, [ticket?.internalNote])

  return (
    <div>
      {!ticket?.internalNote ? (
        <TextButton onClick={() => setIsShown(() => true)}>Add Ticket Note</TextButton>
      ) : (
        <div className='flex flex-col gap-2'>
          <div className='flex gap-2'>
            {!!ticket?.noteChanged && (
              <div className=''>{parseISOToString(ticket.noteChanged)} :</div>
            )}
            {ticket.internalNote}
          </div>
          <div className='flex gap-2'>
            <TextButton onClick={() => setIsShown(() => true)}>Edit Ticket Note</TextButton>
            or
            <TextButton type='delete' onClick={handleEditInternalNote('')}>
              Delete
            </TextButton>
          </div>
        </div>
      )}

      <Modal
        isShown={isShown}
        setIsShown={setIsShown}
        title={`Ticket Note for Ticket #${ticket.id}`}
        style={{ maxWidth: '550px' }}
      >
        <div className='flex flex-col gap-4'>
          <Input
            name='internalNote'
            value={internalNote || ''}
            type='textarea'
            handle={(e) => setInternalNote(() => e.target.value)}
          />
          <div className='flex justify-end'>
            <Button isNotFullWidth onClick={handleEditInternalNote(internalNote || '')}>
              {ticket?.internalNote ? 'Update Ticket Note' : 'Add Ticket Note'}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default TicketInternalNote
